import React from 'react';
import {
  Navigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom-v5-compat';

import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import ClaimDetailsPage from '../../containers/ClaimDetailsPage';
import { DEFAULT_CLAIM_TAB } from '../../constants';
import { knownClaimTab, searchWithoutTab } from '../../utils/claim-tab-helpers';

// Index element for your-claims/:id. Flag-on renders the tabbed detail view;
// flag-off keeps the legacy redirect-to-tab, mapping a canonical ?tab= URL
// (a flag-on bookmark opened after rollback) to its legacy tab path.
export default function ClaimIndexRoute() {
  const { useToggleValue, TOGGLE_NAMES } = useFeatureToggle();
  const useVaTabs = useToggleValue(TOGGLE_NAMES.cstClaimDetailsVaTabs);
  const { search } = useLocation();
  const [searchParams] = useSearchParams();

  if (useVaTabs) {
    return <ClaimDetailsPage />;
  }

  const tab = knownClaimTab(searchParams.get('tab')) ?? DEFAULT_CLAIM_TAB;
  return (
    <Navigate
      to={{ pathname: tab, search: searchWithoutTab(search) }}
      replace
    />
  );
}
